module.exports = __webpack_public_path__ + "img/MainLgo.a55f8abb.png";